import { connectHits } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('col-12')
      li.classList.add('md-col-6')
      li.classList.add('lg-col-4')
      li.classList.add('mb-6')
      li.classList.add('flex')

      li.innerHTML = `
      <div class="project-card">
        <div class="w-full">
          <div class="flex flex-wrap">
            ${hit.thematics
              ? hit.thematics.filter(thematic => thematic.name !== undefined).map(thematic => {
                return `<a href="${thematic.url}" class="thematic thematic--ultralight-blue mr-1 mb-2">${thematic.name}</a>`
              }).join('')
              : ''
            }
          </div>

          <span class="title-4 title-4--medium title-4--white mt-4 block">${hit.title}</span>
          <div class="mt-6">
            ${hit.picture && hit.picture.singleMedia && hit.picture.singleMedia.publicId !== null
              ? hit.hasLogo
                ? `<div class="project-card__logo w-full">
                      <img class="mx-auto project-card__logo-img" src="https://res.cloudinary.com/oieau/image/upload/f_auto,q_auto,w_300/${hit.picture.singleMedia.publicId}" alt="${hit.picture.singleMedia.alt}"/>
                  </div>`
                : `<img class="w-full" src="https://res.cloudinary.com/oieau/image/upload/f_auto,q_auto,c_fill,w_420,h_232/${hit.picture.singleMedia.publicId}" alt="${hit.picture.singleMedia.alt}"/>`
              : ''
            }

              <div class="mt-6 project-card__info">
                ${hit.continent !== undefined || (hit.countries !== undefined && hit.countries.length !== 0) || hit.location !== undefined
                  ? `<div class="flex items-center mb-3">
                    <svg width="32" height="32" class="flex-shrink-0 mr-4 icon icon--ultralight-blue">
                      <use href="#icon-location3" xlink:href="#icon-location3"></use>
                    </svg>
                    <span>
                      ${hit.continent !== null && hit.continent !== undefined ? hit.continent : ''}
                      ${hit.countries !== undefined && hit.countries.length !== 0
                        ? `- ${hit.countries.map((country, i) => {
                          return `${country.title}${i !== hit.countries.length - 1 ? ', ' : ''}`
                        }).join('')}`
                        : ''}
                      ${hit.location !== undefined && hit.location !== null ? `- ${hit.location}` : ''}</span>
                  </div>`
                  : ''}

                ${hit.projectDate !== undefined
                  ? `<div class="flex items-center mb-3">
                      <svg width="32" height="32" class="flex-shrink-0 mr-4 icon icon--ultralight-blue">
                        <use href="#icon-calendar" xlink:href="#icon-calendar"></use>
                      </svg>
                      <span>${hit.projectDate}</span>
                    </div>`
                  : ''
                }
                <div class="flex items-center mb-12">
                    <svg width="32" height="32" class="flex-shrink-0 mr-4 icon icon-man icon--ultralight-blue">
                        <use href="#icon-man" xlink:href="#icon-man"></use>
                    </svg>
                    <span>${hit.client}</span>
                </div>
              </div>
            </div>
        </div>
        <a onclick="_paq.push(['trackEvent', 'Click', '${config.trads['list.project.see']}', '${hit.title}'])"
          href="${hit.path}" class="cta cta--white">${config.trads['list.project.see']}</a>
    </div>
      `

      get('ul', widgetParams.container).appendChild(li)
    })
  } else {
    widgetParams.container.innerHTML = config.trads['list.project.empty']
  }
}

const customHitsProject = connectHits(renderHits)

export default customHitsProject
